export default "__VITE_ASSET__Cxm7ymlP__"